export const head = {
    styles: '',
};
